module.exports = __webpack_public_path__ + "static/media/web.e62967d8.jpeg";